global.slickSliderInit = function (target) {
    let sliders = target.find('.slick')
    sliders.each((i, slider) => {
        const currentArrow = $(slider).find('.slick__arrow')

        let config = {
            infinite: true,
            speed: 500,
            fade: false,
            slide: '',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            vertical: false,
            draggable: true,
            pauseOnHover: false,
            pauseOutside: false,
            asNavFor: null,
            centerMode: false,
            focusOnSelect: true,
            swipeToSlide: true,
            swipeSpeed: null,
            adaptiveHeight: false,
            fadeOutside: false,
            easing: 'ease',
            progressCounter: false,
            appendProgressCounter: null,
            progressBar: false,
            dots: false,
            mouseWeel: false,
            waitForAnimate: false,
            rtl: false,
            reverse: false,
            initialSlide: 0,
            zIndex: 1000,
            prevArrow: (currentArrow.length) ? '' : "<div class='slick__arrow slick__arrow--prev'></div>",
            nextArrow: (currentArrow.length) ? '' : "<div class='slick__arrow slick__arrow--next'></div>",
            responsive: [],
            responsiveTemplate: 'default',
        }

        $.each(config, function (index) {
            if (typeof $(slider).data(index.toLowerCase()) !== 'undefined') {
                config[index] = $(slider).data(index.toLowerCase())
            }
        })

        switch (config.responsiveTemplate) {
            case 'shedule':
                if (config.slidesToShow > 1) {
                    config.responsive.push({
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    })
                }
                if (config.slidesToShow > 2) {
                    config.responsive.push({
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    })
                }
                if (config.slidesToShow > 3) {
                    config.responsive.push({
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    })
                }
                break;
            default:
                if (config.slidesToShow > 1) {
                    config.responsive.push({
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    })
                }
                if (config.slidesToShow > 2) {
                    config.responsive.push({
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    })
                }
                if (config.slidesToShow > 3) {
                    config.responsive.push({
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    })
                }
        }

        /* progressbar classe */
        if (config.progressBar) {
            $(slider).addClass('slick--have-progressbar')
        }

        /* dots classe */
        if (config.dots) {
            $(slider).addClass('slick--have-dots')
        }

        if ($(slider).data('slider')) {
            let jsonData = $(slider).data('slider')
            if (typeof jsonData == 'string') {
                jsonData = jsonData.replace(/'/g, '"')
                jsonData = JSON.parse(jsonData)
            }
            $.extend(config, jsonData)
        }

        const currentSlider = $(slider).slick(config)

        if (config.adaptiveHeight || config.pauseOutside) {
            let slickScrollPause = function () {
                if ($(this).scrollTop() > $(slider).offset().top) {
                    $(slider).slick('slickPause')
                } else {
                    $(slider).slick('slickPlay')
                }
            }

            $(window).scroll(slickScrollPause)
        }

        currentArrow.mousedown(function () {
            if ($(this).hasClass('slick__arrow--prev')) currentSlider.slick('slickPrev')
            if ($(this).hasClass('slick__arrow--next')) currentSlider.slick('slickNext')
        })

        const slickBeforeChange = function (event, slick, currentSlide, nextSlide) {
            const progressCounterContainer = config.appendProgressCounter
                ? config.appendProgressCounter
                : this
            $(progressCounterContainer)
                .find('.slick__counter--current')
                .text(nextSlide + 1)
            $(progressCounterContainer)
                .find('.slick__counter--count')
                .text(
                    slick.slideCount
                    - (!slick.options.infinite
                        ? slick.options.slidesToShow - 1
                        : 0),
                )
            if (config.progressBar) {
                if (!$(this).find('.slick__progress__bar').length) {
                    $(slider).append($('<div class="slick__progress"><div class="slick__progress__bar"></div></div>'))
                }
                $(this).find('.slick__progress__bar').css('width', (100 / slick.slideCount) + '%').css('left', ((100 / slick.slideCount) * nextSlide) + '%')
            }

            let currentSlideClass = $(slick.$slides[currentSlide]).find('> div > div').data('set')
            let currentSlideNextClass = $(slick.$slides[nextSlide]).find('> div > div').data('set')

            if (currentSlideNextClass) {
                $('.site__header').removeClass(currentSlideClass)
                $('.site__header').addClass(currentSlideNextClass)

                $(slider).closest('.block').removeClass('block--' + currentSlide)
                $(slider).closest('.block').addClass('block--' + nextSlide)
                $(slider).closest('.block').removeClass(currentSlideClass)
                $(slider).closest('.block').addClass(currentSlideNextClass)

                $(slider).parent().find('.slick__dots').addClass('block')
                $(slider).parent().find('.slick__dots').removeClass(currentSlideClass)
                $(slider).parent().find('.slick__dots').addClass(currentSlideNextClass)
            }
        }

        const slickAfterChange = function (event, slick, currentSlide) {
            const currentSlideElement = $(slick.$slides[currentSlide])
            if (currentSlideElement.find('video').length) {
                const video = currentSlideElement.find('video').get(0)
                video.pause()
                video.currentTime = 0
                video.play()
            }
        }

        // swipe speed
        if (config.swipeSpeed) {
            let swipeTimeout = null
            let swipeSpeedOriginal = config.speed

            $(slider).on('swipeStart', function (event, slick, direction) {
                slick.setOption('speed', config.swipeSpeed)
            })

            $(slider).on('swipe', function (event, slick, direction) {
                slick.setOption('speed', config.swipeSpeed)
                event.preventDefault()

                clearTimeout(swipeTimeout)
                swipeTimeout = setTimeout(function () {
                    slick.setOption('speed', swipeSpeedOriginal)
                }, config.swipeSpeed)
            })
        }

        // map counter
        $(slider).on('beforeChange', slickBeforeChange)
        $(slider).on('afterChange', slickAfterChange)
        setTimeout(() => {
            slickBeforeChange(null, $(slider).slick('getSlick'), 0, 0)
        }, 10)

        /* add progress counter */
        if (config.progressCounter) {
            // map counter
            let slickCounter = $('<div class="slick__counters"></div>')
            $(slickCounter).append($('<div class="slick__counter slick__counter--current">1</div>'))
            $(slickCounter).append($('<div class="slick__counter slick__counter--count">1</div>'))
            $(slider).append(slickCounter)
        }

        /* fade elements when go outside */
        if (config.fadeOutside) {
            setInterval(() => {
                const slides = $(slider).find('.slick__slide')
                let slick = $(slider).slick('getSlick')

                let slideParent = slides.first().closest('.slick')

                if (slideParent.find('.slick__track').css('transform') != slideParent.data('current')) {

                    let slideParentLeft = slideParent.offset().left - 20
                    let slideParentRight = slideParent.offset().left + slideParent.width() + 20

                    slideParent.data('current', slideParent.find('.slick__track').css('transform'))

                    let firstVisible = true
                    slides.each(function () {
                        let slide = $(this)
                        let slideLeft = slide.offset().left
                        let slideRight = slide.offset().left + slide.width()

                        let newOpacity = 1

                        if (slideLeft < slideParentLeft) {
                            slide.addClass('slick__slide--hidden')
                            slide.removeClass('slick__slide--visible')
                            newOpacity = slideParentLeft - slideLeft
                            newOpacity = 1 - ((newOpacity) * 0.0025)
                        } else if (slideRight > slideParentRight) {
                            slide.addClass('slick__slide--hidden')
                            slide.removeClass('slick__slide--visible')
                            newOpacity = slideRight - slideParentRight
                            newOpacity = 1 - ((newOpacity) * 0.0025)
                        } else {
                            slide.removeClass('slick__slide--hidden')
                            slide.addClass('slick__slide--visible')

                            if (firstVisible) {
                                firstVisible = false
                                $(slider).find('.slick__counter--current').text(slide.data('slick-index') + 1)
                            }
                        }

                        if (newOpacity < 0) newOpacity = 0
                        slide.css('opacity', newOpacity)
                    })
                }
            }, 20)
        }

        /* change dots content */
        if (config.dots) {
            $(slider)
                .find('.slick__dots li')
                .each(function () {
                    const label = $(
                        $(slider).find('.slick__slide > div > div')[
                        $(this).index() + (config.fade ? 0 : 1)
                            ],
                    ).data('dot')
                    $(this).html(label)
                })
        }

        /* Support mouse weel */
        if (config.mouseWeel) {
            let wheelWait = false
            currentSlider.on('wheel', function (e) {
                if (e.originalEvent.deltaX) {
                    e.preventDefault()
                    if (!wheelWait) {
                        if (e.originalEvent.deltaX > 0) {
                            $(this).slick('slickNext')
                        } else {
                            $(this).slick('slickPrev')
                        }
                        wheelWait = true
                        setTimeout(() => {
                            wheelWait = false
                        }, 50)
                    }
                }
            })
        }
    })
}
